<div class="category-details">
    <div class="intro">
        <h2 class="mat-display-2">Details zum Kategory</h2>
    </div>
    <div class="details" *ngIf="category !== undefined">
      <a routerLink="/program" class="list">Zurück zur Kategorie liste</a>
        <mat-card class="example-card">
            <mat-card-header>
                <mat-card-title>{{category.name}}</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <p>
                {{category.description}}
              </p>
            </mat-card-content>
        </mat-card>
    </div>
</div>